import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const ZEELAND = [51.4988, 3.6136];

const icon = L.icon({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const esc = (s) => String(s || "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export const StoriesMap = ({ stories }) => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const clusterRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || !containerRef.current) return;
    const map = L.map(containerRef.current).setView(ZEELAND, 9);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap",
      maxZoom: 19,
    }).addTo(map);
    clusterRef.current = L.markerClusterGroup({ maxClusterRadius: 50 });
    map.addLayer(clusterRef.current);
    mapRef.current = map;
    setTimeout(() => map.invalidateSize(), 200);
  }, []);

  useEffect(() => {
    if (!clusterRef.current) return;
    clusterRef.current.clearLayers();
    const pts = [];
    (stories || []).forEach((s) => {
      if (typeof s.lat !== "number" || typeof s.lng !== "number") return;
      const photo = s.photos && s.photos[0]
        ? `<img src="${BACKEND}${s.photos[0]}" style="width:100%;height:120px;object-fit:cover;margin-bottom:8px;border-radius:4px" />`
        : "";
      const place = s.locality || s.location_text || "";
      const html = `<div style="max-width:230px;font-family:Montserrat,sans-serif">${photo}
        <strong style="color:#0D3B4C;font-size:15px">${esc(s.name)}</strong>
        ${place ? `<div style="font-size:11px;color:#1B6B2E;font-weight:600;margin-top:2px">${esc(place)}</div>` : ""}
        <p style="color:#0D3B4C;font-size:12px;margin:6px 0 8px">${esc(s.story).slice(0, 120)}${s.story.length > 120 ? "…" : ""}</p>
        <a href="/verhalen/${s.id}" style="display:inline-block;background:#B71C1C;color:#fff;font-weight:700;font-size:12px;text-decoration:none;padding:7px 14px;border-radius:9999px">Lees volledig verhaal →</a>
      </div>`;
      const m = L.marker([s.lat, s.lng], { icon });
      m.bindPopup(html);
      clusterRef.current.addLayer(m);
      pts.push([s.lat, s.lng]);
    });
    if (pts.length > 0 && mapRef.current) {
      try { mapRef.current.fitBounds(pts, { padding: [40, 40], maxZoom: 12 }); } catch (e) { console.error("fitBounds mislukt:", e); }
    }
  }, [stories]);

  return <div ref={containerRef} data-testid="stories-map" className="w-full h-[460px] border-2 border-[#E8F5E9] z-0" />;
};
